import { atom } from "recoil";

const usersAtom = atom({
  key: 'users',
  default: {
    payload: [],
    loading: false
  }
});

const crudUserAtom = atom({
  key: 'crudUser',
  default: {
    status: 500,
    message: '',
    loading: false
  }
});

export { crudUserAtom, usersAtom };